<div class="report-details-wrapper">
  <app-report-details-item
    [data]="chartData"
    [reportType]="reportType"
    [isYearlyError]="isYearlyError"
    [isMonthlyError]="isMonthlyError"
  >
  </app-report-details-item>
</div>
